import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators,  FormControl
   } from '@angular/forms';
import { Building } from "../building.model";
import { DataService } from "../service/buildings.service";
import OlMap from "ol/Map";
import OlXYZ from "ol/source/XYZ";
import OlTileLayer from "ol/layer/Tile";
import OlView from "ol/View";
import Draw from "ol/interaction/Draw";
import Snap from "ol/interaction/Snap";
import Point from "ol/geom/Point.js";
import { fromLonLat } from "ol/proj";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer.js";
import { OSM, Vector as VectorSource } from "ol/source.js";
import Feature from "ol/Feature.js";

import { Circle as CircleStyle, Fill, Icon, Stroke, Style } from "ol/style.js";
import { Observable, Observer } from "rxjs";
import { getBottomLeft, getTopRight } from "ol/extent.js";
import { toLonLat } from "ol/proj.js";
import { Router } from "@angular/router";
declare var ol: any;

@Component({
  selector: 'app-sell',
  templateUrl: './sell.component.html',
  styleUrls: ['./sell.component.scss'],
})
export class SellComponent implements OnInit {


  /************************************** */
  clientTypecontrol = new FormControl('', [Validators.required]); 

  buildingTypecontrol = new FormControl('', [Validators.required]); 
  
  buildingTypeGroupcontrol = new FormControl('', [Validators.required]); 

  sizeNamecontrol = new FormControl('', [Validators.required]); 

  districtcontrol = new FormControl('', [Validators.required]); 

  statecontrol = new FormControl('', [Validators.required]); 

  buildActioncontrol = new FormControl('', [Validators.required]); 

  priceTypecontrol = new FormControl('', [Validators.required]); 

  zipcodeFormControl= new FormControl('', [Validators.required]);

  addressFormControl= new FormControl('', [Validators.required]);

  titleFormControl = new FormControl("", [
    Validators.required,
   
  ]);

  totalRoomsFormControl = new FormControl("", [
    Validators.required,
   
  ]);

  sizeFormControl = new FormControl("", [
    Validators.required,
   
  ]);

  phoneFormControl = new FormControl("", [
    Validators.required,
   
  ]);

  latitude: any ;
  longitude: any ;
  img: undefined;
  map: OlMap;
  source: OlXYZ;
  layer: OlTileLayer;
  mapView: OlView;
  startMarker: Feature;

  startMarker2: Feature;
  vectorLayer: VectorLayer;

  vectorLayer2: VectorLayer;
  icon: any;
  snap: any;


  markerSource: any;
  markerStyle: any;

  selectedBuildingTypeGroup: any;

  selectedState: any;

  selectedDistrict: number;

  cultureId: number;

  // matcher = new MyErrorStateMatcher();

  createForm: FormGroup;

  buildings: Building = new Building();

  moneytype: string[] = [];

  region: string[] = [];

  district: string[] = [];

  buildingtype: string[] = [];

  buildingtypegroup: string[] = [];

  sizeType: string[] = [];

  buildAction = [];

  appliances = [];

  basement = [];

  archStyle = [];

  buildTech = [];

  exterior = [];

  indoorFeature = [];

  outdoorAmenity = [];

  coolingtype = [];

  heatingType = [];

  heatingFuel = [];

  floorCovering = [];

  roof = [];

  view = [];

  country = [];

  rooms = [];

  clientType: string[] = [];

  selectedFile = null;

  technoList = [];

  appliancesList = [];

  indoorFeatureList = [];

  outdoorAmenitylist = [];

  exteriorList = [];

  coolingTypeList = [];

  heatingTypeList = [];

  heatingFuelList = [];

  floorCoveringList = [];

  roofList = [];

  viewList = [];

  metro = [];

  zone = [];

  metroList = [];

  zoneList = [];

  roomList = [];
  formData2: FormData = new FormData();
  /************************************** */
  groupHomeDetails: FormGroup;
  secondFormGroup: FormGroup;

  optionsHomeTitle = {
    minLength: 8,
    maxLength: 32,
    errorMessage: 'error',
  };

  optionsHomePrice = {
    minValue: 50,
    maxValue: 999999999,
    errorMessage: 'error',
  };

  optionsHomeYear = {
    minYear: 1970,
    maxYear: 2019,
    errorMessageBuilt: 'error',
    errorMessageReconstruction: 'error',
  };

  optionsBuildingLotSize = {
    minSize: 1,
    maxSize: 999,
    errorMessage: 'error',
  };

  optionsBuildingRooms = {
    minRooms: 1,
    maxRooms: 200,
    errorMessage: 'error',
  };

  buildingImages = [];
  buildingImagesPreview = [];
  buildingImagesDropZoneActive = false;

  buildingVideos = [];
  buildingVideosPreview = [];
  buildingVideosDropZoneActive = false;

  constructor(private _formBuilder: FormBuilder,
    private service: DataService,) {
      this.createForm = this._formBuilder.group({
        buildTitle: [null, Validators.required],
        architecturalStyleId: [null, Validators.required],
        buildTypeId: [null, Validators.required],
        basementId: [null, Validators.required],
        totalRooms: [null, Validators.required],
        yearBuilt: [null, Validators.required],
        structuralRemodelYear: [null, Validators.required],
        description: [null, Validators.required],
          editDate: "0001-01-01T00:00:00+05:00",
          address: [
            "",
            Validators.compose([
              Validators.required
            ])
          ],
        clientTypeId: [null, Validators.required],
        ownerPrice: [null, Validators.required],
          active: true,
        size: [null, Validators.required],
        sizeNameId: [null, Validators.required],
          phone: [null, Validators.required],
        buildActionId: [null, Validators.required],
        moneyTypeId: [null, Validators.required],
        buildTypeGroupId: [null, Validators.required],
          ownerTypeId: 1,
          countryId: 1,
          regionId: [null, Validators.required],
          districtId: [null, Validators.required],
        zoneId: [null/*, Validators.required*/],
          latitude: "",
          longitude: "",
          zipCode: "10000",
          userId: 1,
        buildingAppliances: [null/*, Validators.required*/],
          buildingParkings: [],
        buildingRooms: [null/*, Validators.required*/],
        buildingTechnologies: [null/*, Validators.required*/],
        buildingFeatures: [null/*, Validators.required*/],
        buildingCoolingTypes: [null/*, Validators.required*/],
        buildingExteriors: [null/*, Validators.required*/],
        buildingFloorCoverings: [null/*, Validators.required*/],
        buildingHeatingFuels: [null/*, Validators.required*/],
        buildingHeatingTypes: [null/*, Validators.required*/],
          buildingIndoorFeatures: [],
        outdoorAmenity: [null/*, Validators.required*/],
          buildingOpenDays: [],
          buildingOutdoorAmenities: [],
          buildingRoofTypes: [],
          buildingViews: [],
          id: 0,
          photos: null,
          medias: null
        });
      
    

    this.getArchstyle();

    this.getMoneytype();

    this.getRegion();

    this.getBuildingTypeGroup();

    this.getSizeType();

    this.getBuildAction();

    this.getAppliances();

    this.getBasement();

    this.getRoof();

    // this.getView();

    this.getClientType();

    this.getCountry();

    this.getOutdoorAmenity();

    this.getTechno();

   
  }
/********************************************* */
onCheckboxTechno(option, event) {
  if (event.checked) {
    {
      // let val={option.id,option.name};
      this.technoList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.buildTech.length; i++) {
      if (this.technoList[i] == option.id) {
        this.technoList.splice(i, 1);
      }
    }
  }
}
onCheckMetro(option, event) {
  if (event.checked) {
    {
      this.metroList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.metro.length; i++) {
      if (this.metroList[i] == option.id) {
        this.metroList.splice(i, 1);
      }
    }
  }
}
onCheckZone(option, event) {
  if (event.checked) {
    {
      this.zoneList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.zone.length; i++) {
      if (this.zoneList[i] == option.id) {
        this.zoneList.splice(i, 1);
      }
    }
  }
}

onCheckboxAppliances(option, event) {
  if (event.checked) {
    {
      this.appliancesList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.appliances.length; i++) {
      if (this.appliancesList[i] == option.id) {
        this.appliancesList.splice(i, 1);
      }
    }
  }
}
onCheckboxIndoorFeature(option, event) {
  if (event.checked) {
    {
      this.indoorFeatureList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.indoorFeature.length; i++) {
      if (this.indoorFeatureList[i] == option.id) {
        this.indoorFeatureList.splice(i, 1);
      }
    }
  }
}
onCheckboxOutdoorAmenity(option, event) {
  if (event.checked) {
    {
      this.outdoorAmenitylist.push(option.id);
    }
  } else {
    for (var i = 0; i < this.outdoorAmenity.length; i++) {
      if (this.outdoorAmenitylist[i] == option.id) {
        this.outdoorAmenitylist.splice(i, 1);
      }
    }
  }
}
onCheckboxExterior(option, event) {
  if (event.checked) {
    {
      this.exteriorList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.exterior.length; i++) {
      if (this.exteriorList[i] == option.id) {
        this.exteriorList.splice(i, 1);
      }
    }
  }
}
onCheckboxCoolingType(option, event) {
  if (event.checked) {
    {
      this.coolingTypeList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.coolingtype.length; i++) {
      if (this.coolingTypeList[i] == option.id) {
        this.coolingTypeList.splice(i, 1);
      }
    }
  }
}

onCheckboxHeatingType(option, event) {
  if (event.checked) {
    {
      this.heatingTypeList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.heatingType.length; i++) {
      if (this.heatingTypeList[i] == option.id) {
        this.heatingTypeList.splice(i, 1);
      }
    }
  }
}
onCheckboxHeatingFuel(option, event) {
  if (event.checked) {
    {
      this.heatingFuelList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.heatingFuel.length; i++) {
      if (this.heatingFuelList[i] == option.id) {
        this.heatingFuelList.splice(i, 1);
      }
    }
  }
}
onCheckboxFloorCovering(option, event) {
  if (event.checked) {
    {
      this.floorCoveringList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.floorCovering.length; i++) {
      if (this.floorCoveringList[i] == option.id) {
        this.floorCoveringList.splice(i, 1);
      }
    }
  }
}
onCheckboxRoof(option, event) {
  if (event.checked) {
    {
      this.roofList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.roof.length; i++) {
      if (this.roofList[i] == option.id) {
        this.roofList.splice(i, 1);
      }
    }
  }
}
onKeyUpRoom(option, event) {
  let found = false;

  for (var i = 0; i < this.roomList.length; i++) {
    if (this.roomList[i].RoomType == option.key && event) {
      this.roomList[i].RoomCount = event;
      found = true;
    }
  }

  if(found) return;

  this.roomList.push({
    RoomType: option.key,
    RoomCount: event
  });
}
onCheckboxView(option, event) {
  if (event.checked) {
    {
      this.viewList.push(option.id);
    }
  } else {
    for (var i = 0; i < this.view.length; i++) {
      if (this.viewList[i] == option.id) {
        this.viewList.splice(i, 1);
      }
    }
  }
}
addForm: FormGroup;
onFormSubmit(createForm) {

 console.log("onformsubmit");
 
  this.createForm.value.Technologies = this.technoList;

  this.createForm.value.appliances = this.appliancesList;

  this.createForm.value.metro = this.metroList;

  this.createForm.value.zone = this.zoneList;

  this.createForm.value.indoorFeature = this.indoorFeatureList;

  this.createForm.value.outdoorAmenity = this.outdoorAmenitylist;

  this.createForm.value.exterior = this.exteriorList;

  this.createForm.value.floorCovering = this.floorCoveringList;

  this.createForm.value.heatingFuel = this.heatingFuelList;

  this.createForm.value.heatingType = this.heatingType;

  this.createForm.value.roof = this.roofList;

  this.createForm.value.view = this.viewList;
  
  console.log("long"+this.longitude);

  console.log("lat"+this.latitude);
  

  this.formData2.append(
    "longitude",this.longitude
  );
  
  this.formData2.append(
        "latitude",this.latitude
      );
  
  this.formData2.append(
    "buildTitle",
    this.createForm.get("buildTitle").value
  );

  if (this.viewList.length > 0)
    for (var i = 0; i < this.viewList.length; i++) {
      this.formData2.append(
        "buildingViews[" + i + "].ViewId",
        this.viewList[i]
      );
    }
  else {
  }

  if (this.appliancesList.length > 0)
    for (var i = 0; i < this.appliancesList.length; i++) {
      this.formData2.append(
        "buildingAppliances[" + i + "].ApplianceId",
        this.appliancesList[i]
      );
    }
  else {
  }
  if (this.roomList.length > 0)
    for (var i = 0; i < this.roomList.length; i++) {
      this.formData2.append(
        "buildingRooms[" + i + "].RoomType",
        this.roomList[i].RoomType
      );
      this.formData2.append(
        "buildingRooms[" + i + "].RoomCount",
        this.roomList[i].RoomCount
      );
    }
  else {
  }

  this.formData2.append("address", this.createForm.get("address").value);

  this.formData2.append(
    "description",
    this.createForm.get("description").value
  );

  this.formData2.append(
    "clientTypeId",
    this.createForm.get("clientTypeId").value
  );

  this.formData2.append("countryId", "1");

  this.formData2.append("ownerTypeId", "1");

  this.formData2.append(
    "architecturalStyleId",
    this.createForm.get("architecturalStyleId").value
  );
  this.formData2.append(
    "ownerPrice",
    this.createForm.get("ownerPrice").value
  );

  this.formData2.append(
    "moneyTypeId",
    this.createForm.get("moneyTypeId").value
  );

  this.formData2.append("yearBuilt", this.createForm.get("yearBuilt").value);

  this.formData2.append(
    "structuralRemodelYear",
    this.createForm.get("structuralRemodelYear").value
  );
  this.formData2.append(
    "basementId",
    this.createForm.get("basementId").value
  );

  this.formData2.append(
    "sizeNameId",
    this.createForm.get("sizeNameId").value
  );

  this.formData2.append(
    "buildTypeGroupId",
    this.createForm.get("buildTypeGroupId").value
  );

  this.formData2.append(
    "buildTypeId",
    this.createForm.get("buildTypeId").value
  );

  this.formData2.append("regionId", this.createForm.get("regionId").value);

  this.formData2.append(
    "districtId",
    this.createForm.get("districtId").value
  );

  // formData2.append("metroId", this.createForm.get("metroId").value);

  // formData2.append("metroId", this.createForm.get("metroId").value);
  this.formData2.append("size", this.createForm.get("size").value);

  this.formData2.append(
    "buildActionId",
    this.createForm.get("buildActionId").value
  );

  this.formData2.append("phone", this.createForm.get("phone").value);

  if (this.technoList.length > 0)
    for (var i = 0; i < this.technoList.length; i++) {
      this.formData2.append(
        "buildingTechnologies[" + i + "].TechnologyId",
        this.technoList[i]
      );
    }
  else {
  }

  if (this.floorCoveringList.length > 0)
    for (var i = 0; i < this.floorCoveringList.length; i++) {
      this.formData2.append(
        "buildingFloorCoverings[" + i + "].FloorCoveringId",
        this.floorCoveringList[i]
      );
    }
  else {
  }
  if (this.indoorFeatureList.length > 0)
    for (var i = 0; i < this.indoorFeatureList.length; i++) {
      this.formData2.append(
        "buildingIndoorFeatures[" + i + "].IndoorFeatureId",
        this.indoorFeatureList[i]
      );
    }
  else {
  }
  if (this.outdoorAmenitylist.length > 0)
    for (var i = 0; i < this.outdoorAmenitylist.length; i++) {
      this.formData2.append(
        "buildingOutdoorAmenities[" + i + "].OutdoorAmenityId",
        this.outdoorAmenitylist[i]
      );
    }
  else {
  }

  if (this.exteriorList.length > 0)
    for (var i = 0; i < this.exteriorList.length; i++) {
      this.formData2.append(
        "buildingExteriors[" + i + "].ExteriorId",
        this.exteriorList[i]
      );
    }
  else {
  }

  if (this.heatingFuelList.length > 0)
    for (var i = 0; i < this.heatingFuelList.length; i++) {
      this.formData2.append(
        "buildingHeatingFuels[" + i + "].HeatingFuelId",
        this.heatingFuelList[i]
      );
    }
  else {
  }

  if (this.heatingTypeList.length > 0)
    for (var i = 0; i < this.heatingTypeList.length; i++) {
      this.formData2.append(
        "buildingHeatingTypes[" + i + "].HeatingTypeId",
        this.heatingTypeList[i]
      );
    }
  else {
  }

  if (this.coolingTypeList.length > 0)
    for (var i = 0; i < this.coolingTypeList.length; i++) {
      this.formData2.append(
        "buildingCoolingTypes[" + i + "].CoolingTypeId",
        this.coolingTypeList[i]
      );
    }
  else {
  }

  if (this.roofList.length > 0)
    for (var i = 0; i < this.roofList.length; i++) {
      this.formData2.append(
        "buildingRoofTypes[" + i + "].RoofTypeId",
        this.roofList[i]
      );
    }
  else {
  }
console.log("form:"+this.formData2.get("buildTitle"));
  this.service.createBuilding(this.formData2);

}
Map() {
  this.source = new VectorSource({ wrapX: false });

  this.layer = new TileLayer({
    source: new OSM()
  });

  this.startMarker = new Feature({
    geometry: new Point(fromLonLat([6.661594, 50.433237]))
  });

  this.startMarker.setStyle(
    new Style({
      image: new Icon(
        /** @type {module:ol/style/Icon~Options} */ ({
          crossOrigin: "anonymous",
          anchor: [0.5, 0.96],
          src:
            "https://cdn3.iconfinder.com/data/icons/map-markers-1/512/residence-512.png",
          scale: 0.09
        })
      )
    })
  );

  this.mapView = new OlView({
    center: fromLonLat([69.2401, 41.2995]),
    zoom: 12
  });
  this.vectorLayer = new VectorLayer({
    source: this.source
  });

  this.map = new OlMap({
    target: "map",
    layers: [this.layer, this.vectorLayer],
    view: this.mapView
  });
  let self = this;
  this.map.on("moveend", function(e) {
    var map = e.map;

    var extent = map.getView().calculateExtent(map.getSize());

    // this.view.fit(this.vectorLayer.getSource().getExtent(), {duration: 1000})

    var bottomLeft = toLonLat(getBottomLeft(extent));

    var topRight = toLonLat(getTopRight(extent));
  });

  this.map.on(
    "click",
    function(e) {
      self.map.removeLayer(this.vectorLayer)
     
      let point=ol.proj.toLonLat(e.coordinate);

this.longitude=point[0].toString().replace('.',',');
  

this.latitude=point[1].toString().replace('.',',');

      this.startMarker = new Feature({
        geometry: new Point(e.coordinate)
      });

      this.startMarker.setStyle(
        new Style({
          image: new Icon(
            /** @type {module:ol/style/Icon~Options} */ ({
              crossOrigin: "anonymous",
              anchor: [0.5, 0.96],
              src:
                "https://cdn3.iconfinder.com/data/icons/map-markers-1/512/residence-512.png",
              scale: 0.09
            })
          )
        })
      );

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [this.startMarker]
        })
      });

      this.map.addLayer(this.vectorLayer);
    }.bind(this)
  );

  let draw = new Draw({
    source: this.source,
    type: "Polygon",
    freehand: true
  });

  // draw.on(
  //   "drawend",
  //   function(e) {
  //     var currentFeature = e.feature; //this is the feature fired the event
  //     var restOfFeats = this.source.getFeatures(); //rest of feats
  //     var allFeats = restOfFeats.concat(currentFeature); //concatenate the event feat to the array of source feats
  //     console.log(allFeats.length);
  //   }.bind(this)
  // );
  draw.on(
    "drawend",
    function() {
      this.map.addInteraction(draw);
    }.bind(this)
  );

}
/********************************************* */
  ngOnInit() {
    this.getCoolingType();

    /*************************** */
    this.Map();
    this.getRoom();
    
    this.getExterior();

    this.getIndoorFeature();

    

    this.getHeatingType();
    // this.getHeatingFuel();

    // this.getFloorCovering();
 

    this.cultureId = 1;
    /*************************** */
    this.groupHomeDetails = this._formBuilder.group({
      buildTitle: [
        null,
        // [
        //   Validators.required,
        //   Validators.minLength(this.optionsHomeTitle.minLength),
        //   Validators.maxLength(this.optionsHomeTitle.maxLength),
        // ],
      ],
      clientTypeId: [null],// Validators.required],
      moneyTypeId: [null],// Validators.required],
      ownerPrice: [
        null,
        // [
        //   Validators.required,
        //   Validators.min(this.optionsHomePrice.minValue),
        //   Validators.max(this.optionsHomePrice.maxValue),
        // ],
      ],
      buildActionId: [null],// Validators.required],
      yearBuilt: [
        null,
        // [
        //   Validators.min(this.optionsHomeYear.minYear),
        //   Validators.max(this.optionsHomeYear.maxYear),
        // ],
      ],
      structuralRemodelYear: [
        null,
        // [
        //   Validators.min(this.optionsHomeYear.minYear),
        //   Validators.max(this.optionsHomeYear.maxYear),
        // ],
      ],
      buildTypeGroupId: [null],//Validators.required],
      buildTypeId: [null],// Validators.required],
      regionId: [null],// Validators.required],
      districtId: [null],// Validators.required],
      metroId: [null],
      zipcode: [null],
      address: [null],
      buildingImages: [null],
      buildingBasement: [null],// Validators.required],
      architecturalStyleId: [null],// Validators.required],
      buildingAppliances: [null],
      buildingIndoorFeatures: [null],
      buildingOutdoorAmenities: [null],
      buildingCoolingSystem: [null],
      buildingHeatingSystem: [null],
      buildingHeatingMethod: [null],
      buildingFloorCover: [null],
      buildingRoofType: [null],
      buildingSurrounding: [null],
      sizeNameId: [null],// Validators.required],
      size: [
        null,
        // [
        //   Validators.required,
        //   Validators.min(this.optionsBuildingLotSize.minSize),
        //   Validators.max(this.optionsBuildingLotSize.maxSize),
        // ],
      ],
      phoneNumber: [
        null,
        // [Validators.required, Validators.pattern('^[0-9]{10,12}$')],
      ],
      description: [null],//, Validators.required],
      buildingRooms: [
        null,
        // [
        //   Validators.min(this.optionsBuildingRooms.minRooms),
        //   Validators.max(this.optionsBuildingRooms.maxRooms),
        // ],
      ],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: [null], //, Validators.required],
    });

  this.onChanges();
  }
  onFileSelected(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      for (var i = 1; i <= fileList.length; i++) {
        let file: File = fileList[i];
        this.formData2.append("photos", file, file.name);
      }
    }
  }

  onFileSelectedVideo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      for (var i = 1; i <= fileList.length; i++) {
        let file: File = fileList[i];
        this.formData2.append("medias", file, file.name);
      }
    }
  }
  getIndoorFeature() {
    var self = this;
    this.service.getIndoorFeature().subscribe({
      next(data) {
        self.indoorFeature = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getRoom() {
    var self = this;
    this.service.getRooms().subscribe({
      next(data) {
        self.rooms = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getCountry() {
    var self = this;
    this.service.getCountry().subscribe({
      next(data) {
        self.country = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getOutdoorAmenity() {
    var self = this;

    this.service.getOutdoorAmenity().subscribe({
      next(data) {
        self.outdoorAmenity = data;
       
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }
  getView() {
    var self = this;

    this.service.getView().subscribe({
      next(data) {
        self.view = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getClientType() {
    var self = this;

    this.service.getClientType().subscribe({
      next(data) {
        self.clientType = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getHeatingType() {
    
    var self = this;

    this.service.getHeatingType().subscribe({
      next(data) {
        self.heatingType = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getRoof() {
    var self = this;

    this.service.getRoofType().subscribe({
      next(data) {
        self.roof = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getFloorCovering() {
    var self = this;

    this.service.getFloorCovering().subscribe({
      next(data) {
        self.floorCovering = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getHeatingFuel() {
    var self = this;
    this.service.getHeatingFuel().subscribe({
      next(data) {
        self.heatingFuel = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getCoolingType() {
    var self = this;
    this.service.getCoolingType().subscribe(
    {
      next(data) {
        self.coolingtype = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }
  getExterior() {
    var self = this;
    this.service.getExterior().subscribe({
      next(data) {
        self.exterior = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getTechno() {
    var self = this;
    console.log("gettechno");
    this.service.getBuildTech().subscribe({
      next(data) {
        self.buildTech = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getMoneytype() {
    var self = this;
    this.service.getMoneyType().subscribe({
      next(data) {
        self.moneytype = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getAppliances() {
    
    console.log("getAppliances");
    var self = this;
    this.service.getAppliances().subscribe({
      next(data) {
        self.appliances = data;
        
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getArchstyle() {
    console.log("getArchstyle");
    var self = this;
    this.service.getArchitecturalStyle().subscribe({
      next(data) {
        self.archStyle = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getBasement() {
    console.log("getBasement");
    var self = this;
    this.service.getBasement().subscribe({
      next(data) {
        self.basement = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }
  getRegion() {
    
    var self = this;
    this.service.getRegion().subscribe({
      next(data) {
        self.region = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }
  getMetroandZones() {
    var self = this;

    this.service
      .getMetro(this.selectedDistrict)

      .subscribe({
        next(data) {
          self.metro = data;
        },
        error(msg) {
          console.log("Error Getting data: ", msg);
        }
      });

    this.service
      .getZone(this.selectedDistrict)

      .subscribe({
        next(data) {
          self.zone = data;
        },
        error(msg) {
          console.log("Error Getting data: ", msg);
        }
      });
  }
  getDistrict() {
    var self = this;

    this.service
      .getDistrict(this.selectedState)

      .subscribe({
        next(data) {
          self.district = data;
        },
        error(msg) {
          console.log("Error Getting data: ", msg);
        }
      });
  }

  getBuildingTypeGroup() {
    var self = this;

    this.service.getBuildTypeGroup().subscribe({
      next(data) {
        self.buildingtypegroup = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  onBuildingTypeGroup() {
    
    
    var self = this;

    this.service
      .getBuildType(this.selectedBuildingTypeGroup)

      .subscribe({
        next(data) {
          self.buildingtype = data;
       
      
        },
        error(msg) {
          console.log("Error Getting data: ", msg);
        }
      });
  }
  getSizeType() {
    var self = this;

    this.service.getSizeType().subscribe({
      next(data) {
        self.sizeType = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }

  getBuildAction() {
    var self = this;

    this.service.getBuildAction().subscribe({
      next(data) {
        self.buildAction = data;
      },
      error(msg) {
        console.log("Error Getting data: ", msg);
      }
    });
  }
  onChanges() {
    // this.groupHomeDetails.get('ownerPrice').disable();
    // this.groupHomeDetails.get('moneyTypeId').valueChanges.subscribe(selected => {
    //   if (!selected) {
    //     this.groupHomeDetails.get('ownerPrice').disable();
    //   } else {
    //     this.groupHomeDetails.get('ownerPrice').enable();
    //   }

    //   this.groupHomeDetails.get('ownerPrice').reset();
    // });

    // this.groupHomeDetails.get('buildTypeId').disable();
    // this.groupHomeDetails
    //   .get('buildTypeGroupId')
    //   .valueChanges.subscribe(selected => {
    //     if (!selected) {
    //       this.groupHomeDetails.get('buildTypeId').disable();
    //     } else {
    //       this.groupHomeDetails.get('buildTypeId').enable();
    //     }

    //     this.groupHomeDetails.get('buildTypeId').reset();
    //   });

    // this.groupHomeDetails.get('districtId').disable();
    // this.groupHomeDetails.get('regionId').valueChanges.subscribe(selected => {
    //   if (!selected) {
    //     this.groupHomeDetails.get('districtId').disable();
    //   } else {
    //     this.groupHomeDetails.get('districtId').enable();
    //   }

    //   this.groupHomeDetails.get('districtId').reset();
    // });

    // this.groupHomeDetails.get('metroId').disable();
    // this.groupHomeDetails
    //   .get('districtId')
    //   .valueChanges.subscribe(selected => {
    //     if (!selected) {
    //       this.groupHomeDetails.get('metroId').disable();
    //     } else {
    //       this.groupHomeDetails.get('metroId').enable();
    //     }

    //     this.groupHomeDetails.get('metroId').reset();
    //   });

    // this.groupHomeDetails.get('size').disable();
    // this.groupHomeDetails
    //   .get('sizeNameId')
    //   .valueChanges.subscribe(selected => {
    //     if (!selected) {
    //       this.groupHomeDetails.get('size').disable();
    //     } else {
    //       this.groupHomeDetails.get('size').enable();
    //     }

    //     this.groupHomeDetails.get('size').reset();
    //   });
  }

 


  

  isValidHomeTitle(): boolean {
    if (!this.groupHomeDetails.get('buildTitle').value) {
     
      this.optionsHomeTitle.errorMessage = 'You must type a title';
      return false;
    } else if (
      this.groupHomeDetails.get('buildTitle').value.length <
      this.optionsHomeTitle.minLength
    ) {
      this.optionsHomeTitle.errorMessage =
        'Min title is ' + this.optionsHomeTitle.minLength;
      return false;
    } else if (
      this.groupHomeDetails.get('buildTitle').value.length >
      this.optionsHomeTitle.maxLength
    ) {
      this.optionsHomeTitle.errorMessage =
        'Max title is ' + this.optionsHomeTitle.maxLength;
      return false;
    }

    return true;
  }

  isValidHomePrice(): boolean {
    if (!this.groupHomeDetails.get('ownerPrice').value) {
      this.optionsHomePrice.errorMessage = 'You must set a price';
      return false;
    } else if (
      this.groupHomeDetails.get('ownerPrice').value <
      this.optionsHomePrice.minValue
    ) {
      this.optionsHomePrice.errorMessage =
        'Minimum price is ' + this.optionsHomePrice.minValue;
      return false;
    } else if (
      this.groupHomeDetails.get('ownerPrice').value >
      this.optionsHomePrice.maxValue
    ) {
      this.optionsHomePrice.errorMessage =
        'Max price is ' + this.optionsHomePrice.maxValue;
      return false;
    }

    return true;
  }

  isValidHomeBuiltYear(): boolean {
    if (
      this.groupHomeDetails.get('yearBuilt').value <
        this.optionsHomeYear.minYear ||
      this.groupHomeDetails.get('yearBuilt').value >
        this.optionsHomeYear.maxYear
    ) {
      this.optionsHomeYear.errorMessageBuilt = 'Invalid year';
      return false;
    }

    return true;
  }

  isValidHomeReconstructionYear(): boolean {
    if (
      this.groupHomeDetails.get('structuralRemodelYear').value <
        this.optionsHomeYear.minYear ||
      this.groupHomeDetails.get('structuralRemodelYear').value >
        this.optionsHomeYear.maxYear
    ) {
      this.optionsHomeYear.errorMessageReconstruction = 'Invalid year';
      return false;
    }

    return true;
  }

  isValidBuildingLotSize(): boolean {
    if (!this.groupHomeDetails.get('size').value) {
      this.optionsBuildingLotSize.errorMessage = 'You must set a lot size';
      return false;
    } else if (
      this.groupHomeDetails.get('size').value <
      this.optionsBuildingLotSize.minSize
    ) {
      this.optionsBuildingLotSize.errorMessage =
        'Minimum lot size is ' + this.optionsBuildingLotSize.minSize;
      return false;
    } else if (
      this.groupHomeDetails.get('size').value >
      this.optionsBuildingLotSize.maxSize
    ) {
      this.optionsBuildingLotSize.errorMessage =
        'Max lot size is ' + this.optionsBuildingLotSize.maxSize;
      return false;
    }

    return true;
  }

  isValidBuildingRooms(): boolean {
    if (
      this.groupHomeDetails.get('buildingRooms').value <
      this.optionsBuildingRooms.minRooms
    ) {
      this.optionsBuildingRooms.errorMessage =
        'Minimum rooms number is ' + this.optionsBuildingRooms.minRooms;
      return false;
    } else if (
      this.groupHomeDetails.get('buildingRooms').value >
      this.optionsBuildingRooms.maxRooms
    ) {
      this.optionsBuildingRooms.errorMessage =
        'Max rooms number is ' + this.optionsBuildingRooms.maxRooms;
      return false;
    }

    return true;
  }
// next(){
//   this.getCoolingType();
// }
  handleBuildingImages(images: FileList): void {
    if (!images.length) {
      return;
    }

    let same_image = false;

    for (let i = 0; i < images.length; i++) {
       if (!images[i].type.includes('image')) {
         continue;
       }

      for (let j = 0; j < this.buildingImages.length; j++) {
        if (images[i].name === this.buildingImages[j].name) {
          same_image = true;
          break;
        }
      }

      if (same_image === true) {
        same_image = false;
        continue;
      }
      this.formData2.append("photos", images[i], images[i].name);
      this.buildingImages.push(images[i]);
      this.createBuildingImagePreview(images[i]);
    }
  }

  createBuildingImagePreview(image: File): void {
    const reader = new FileReader();
    const image_info = {
      title: null,
      src: null,
    };

    reader.onload = e => {
      image_info.src = reader.result;
      image_info.title = image.name;
      this.buildingImagesPreview.push(image_info);
    };

    reader.readAsDataURL(image);
  }

  deleteBuildingPreviewImage(i): void {
    this.buildingImagesPreview.splice(i, 1);
    this.buildingImages.splice(i, 1);
  }

  getBuildingImagesName(): String {
    if (!this.buildingImages.length) {
      return 'Select images to upload';
    } else {
      let imgNames: String = '';

      for (let i = 0; i < this.buildingImages.length; i++) {
        if (i > 0) {
          imgNames += ', ';
        }

        imgNames += this.buildingImages[i].name;
      }

      return imgNames;
    }
  }

  updateImagesDropZoneState($event: boolean): void {
    this.buildingImagesDropZoneActive = $event;
  }

  handleBuildingVideos(videos: FileList): void {
    if (!videos.length) {
      return;
    }

    let same_video = false;

    for (let i = 0; i < videos.length; i++) {
       if (!videos[i].type.includes('video')) {
         continue;
       }

      for (let j = 0; j < this.buildingVideos.length; j++) {
        if (videos[i].name === this.buildingVideos[j].name) {
          same_video = true;
          break;
        }
      }

      if (same_video === true) {
        same_video = false;
        continue;
      }
      this.formData2.append("medias", videos[i], videos[i].name);
      this.buildingVideos.push(videos[i]);
      this.createBuildingVideoPreview(videos[i]);
    }
  }

  createBuildingVideoPreview(video_file: File): void {
    let hello = this;
    const image_info = {
      title: null,
      src: null,
    };
    var fileReader = new FileReader();
    fileReader.onload = function() {
      var blob = new Blob([fileReader.result], { type: video_file.type });
      var url = URL.createObjectURL(blob);
      var video = document.createElement('video');
      var timeupdate = function() {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
          video.pause();
        }
      };
      video.addEventListener('loadeddata', function() {
        if (snapImage()) {
          video.removeEventListener('timeupdate', timeupdate);
        }
      });
      var snapImage = function() {
        var canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas
          .getContext('2d')
          .drawImage(video, 0, 0, canvas.width, canvas.height);
        var image = canvas.toDataURL();
        var success = image.length > 100000;
        if (success) {
          image_info.src = image;
          image_info.title = video_file.name;
          hello.buildingVideosPreview.push(image_info);
          URL.revokeObjectURL(url);
        }
        return success;
      };
      video.addEventListener('timeupdate', timeupdate);
      video.preload = 'metadata';
      video.src = url;
      // Load video in Safari / IE11
      video.muted = true;
      video.play();
    };
    fileReader.readAsArrayBuffer(video_file);
  }

  deleteBuildingPreviewVideo(i): void {
    this.buildingVideosPreview.splice(i, 1);
    this.buildingVideos.splice(i, 1);
  }

  getBuildingVideosName(): String {
    if (!this.buildingVideos.length) {
      return 'Select videos to upload';
    } else {
      let vidNames: String = '';

      for (let i = 0; i < this.buildingVideos.length; i++) {
        if (i > 0) {
          vidNames += ', ';
        }

        vidNames += this.buildingVideos[i].name;
      }

      return vidNames;
    }
  }

  updateVideosDropZoneState($event: boolean): void {
    this.buildingVideosDropZoneActive = $event;
  }

  resetStepper(stepper): void {
    this.buildingImagesPreview.splice(0);
    this.buildingImages.splice(0);
    stepper.reset();
  }
}
